export const columnDefs = [
    { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'right',width:'2.97%' },xlCol: { dataType: 'number', dataFormatter: null },showfilter:false, },
    { headerName: 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',width:'10.41%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'LR\nDate', field: 'LRDate', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'Party\nName', field: 'PartyName', headerSx: { textAlign: 'left',width:'10.41%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',width:'10.41%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',width:'8.11%'},  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',width:'8.11%' },  xlCol: { dataType: 'string', dataFormatter: null },showfilter:true },
    { headerName: 'GST Invoice\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
    { headerName: 'Total\nOutstanding', field: 'Outstanding', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
    { headerName: 'Voucher\nAmount', field: 'NetAmount', headerSx: { textAlign: 'right',width:'8.11%' },  xlCol: { dataType: 'number', dataFormatter: null },showfilter:true },
]
export const columnDefsForGrouping={
  SN:'S/N',
  LRNO:'LR\nNumber',
  LRDate:'LR\nDate',
  PartyName:'Party\nName',
  GSTN:'Party\nGSTIN',
  PaymentType:'Payment\nType',
  TransactionType:'Voucher Txn.\nType',
  GSTInv:'GST Invoice\nNumber',
  GSTDate:'GST Invoice\nDate',
  GSTAmt:'GST Invoice\nAmount',
  Outstanding:'Total\nOutstanding',
  NetAmount:'Voucher\nAmount'
}
export const columnDefsOneFilter = [
    { headerName: 'Transaction Type', field: 'voucherType', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party City', field: 'partyCity', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party Name', field: 'partyName', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party GSTIN', field: 'PartyGSTIN', headerSx: { textAlign: 'left',minWidth:'295px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
export const tab1Data = [
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
    {srNo:'1',lrNo:'MAHD/23-24/00001',lrDate:'25-Dec-24,09:51',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',invAmount:'50',outstanding:'1000',voucherAmt:'1000'
    },
]
// isSummaryHeader: false,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 0,
export const columnDefsTwo = [
    // { isHeader: true, header: 'Credit Voucher Table' },
    { header: 'S/N',headerName: 'S/N', field: 'srNo', headerSx: { textAlign: 'right',minWidth:'50px' }, showfilter:false ,allowSorting: true,isSelected: true,isDefault: true,isMandatory: true,id: 0, },
    { header: 'Voucher\nNumber',headerName: 'Voucher\nNumber', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'50px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 1,},
    { header: 'Voucher\nDate',headerName: 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 2,},
    { header: 'Booking\nDate',headerName: 'Booking\nDate', field: 'BookingDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 3,},
    { header: 'LR\nNumber',headerName: 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',minWidth:'126px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 4,},
    { header: 'Party\nName',headerName: 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'140px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 5,},
    { header: 'Party\nGSTIN',headerName: 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'125px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 6,},
    { header: 'Payment\nType',headerName: 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',minWidth:'60px'}, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 7,},
    { header: 'Voucher Txn.\nType',headerName: 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'60px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 8,},
    { header: 'GST Invoice\nNumber',headerName: 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',minWidth:'70px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 9,},
    { header: 'GST Invoice\nDate',headerName: 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',minWidth:'120px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 10,},
    { header: 'GST Inv.\nAmount',headerName: 'GST Inv.\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: false,id: 11,},
    { header: 'Voucher\nAmount',headerName: 'Voucher\nAmount', field: 'NetAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 12,},
    { header: 'Amount\nPaid',headerName: 'Amount\nPaid', field: 'TotalPaidAmt', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 13,},
    { header: 'Amount\nPending',headerName: 'Amount\nPending', field: 'NetAmtPending', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 14,},
    { header: 'Discount\nAmount',headerName: 'Discount\nAmount', field: 'Discount', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 15,},
    { header: 'Edit\nDisc.',headerName: 'Edit\nDisc.', field: 'editDisc', headerSx: { textAlign: 'left',minWidth:'70px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 16,},
    { header: 'Net Amt.\nPending',headerName: 'Net Amt.\nPending', field: 'NetAmtToRcv', headerSx: { textAlign: 'left',minWidth:'65px' }, showfilter:true  ,allowSorting: false,isSelected: true,isDefault: true,isMandatory: true,id: 17,},
]

export const columnDefsTwoV2 = [
  { header: 'S/N', headerName: 'S/N', dataKey: 'srNo', headerSx: { textAlign: 'right', minWidth: '50px' }, showfilter: false, allowSorting: true, isSelected: true, isDefault: true, isMandatory: true, id: 1 ,
  xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
    halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 50, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Voucher\nNumber', headerName: 'Voucher\nNumber', dataKey: 'VoucherNo', headerSx: { textAlign: 'left', minWidth: '50px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 2,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
 },
  { header: 'Voucher\nDate', headerName: 'Voucher\nDate', dataKey: 'VoucherDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 3 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Booking\nDate', headerName: 'Booking\nDate', dataKey: 'BookingDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 4 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'LR\nNumber', headerName: 'LR\nNumber', dataKey: 'LRNO', headerSx: { textAlign: 'left', minWidth: '126px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 5 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Party\nName', headerName: 'Party\nName', dataKey: 'Party', headerSx: { textAlign: 'left', minWidth: '140px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 6 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Party\nGSTIN', headerName: 'Party\nGSTIN', dataKey: 'GSTN', headerSx: { textAlign: 'left', minWidth: '125px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 7 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Payment\nType', headerName: 'Payment\nType', dataKey: 'PaymentType', headerSx: { textAlign: 'left', minWidth: '60px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 8,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'Voucher Txn.\nType', headerName: 'Voucher Txn.\nType', dataKey: 'TransactionType', headerSx: { textAlign: 'left', minWidth: '60px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 9,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 100, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'GST Invoice\nNumber', headerName: 'GST Invoice\nNumber', dataKey: 'GSTInv', headerSx: { textAlign: 'left', minWidth: '70px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 10,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 130, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'GST Invoice\nDate', headerName: 'GST Invoice\nDate', dataKey: 'GSTDate', headerSx: { textAlign: 'left', minWidth: '100px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 11 ,
  xlCol: { dataType: 'string', dataFormatter: null },
  pdfColSx: {
    halign: 'left', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 120, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
},
  { header: 'GST Inv.\nAmount', headerName: 'GST Inv.\nAmount', dataKey: 'GSTAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault:false, isMandatory: false, id: 12,
  xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
    halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
  },
 },
  { header: 'Voucher\nAmount', headerName: 'Voucher\nAmount', dataKey: 'NetAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 13,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: 'Amount\nPaid', headerName: 'Amount\nPaid', dataKey: 'TotalPaidAmt', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 14,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: 'Amount\nPending', headerName: 'Amount\nPending', dataKey: 'NetAmtPending', headerSx: { textAlign: 'lerightft', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 15,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: 'Discount\nAmount', headerName: 'Discount\nAmount', dataKey: 'discountValue', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 16,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: 'Edit\nDisc.', headerName: 'Edit\nDisc.', dataKey: 'editDisc', headerSx: { textAlign: 'left', minWidth: '70px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 17,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
  { header: 'Net Amt.\nPending', headerName: 'Net Amt.\nPending', dataKey: 'NetAmtToRcv', headerSx: { textAlign: 'right', minWidth: '65px' }, showfilter: true, allowSorting: false, isSelected: true, isDefault: true, isMandatory: true, id: 18,
 xlCol: { dataType: 'number', dataFormatter: null },
  pdfColSx: {
      halign: 'right', fontSize: 16, fontStyle: 'normal', textColor: [0, 0, 0], minCellWidth: 90, minCellHeight: 36, cellPadding: 6, font: 'Roboto'
    },
},
];
  export const headerTblDefs = [
        { header: 'From Voucher Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: 'To Voucher Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: 'Party City', dataKey: 'partyCity', xlCol: { dataType: 'string', dataFormatter: null } },
        { header: 'Party Name', dataKey: 'partyName', xlCol: { dataType: 'string', dataFormatter: null } },
      ]
export const columnDefstwoFilter = [
    { headerName: 'From Voucher Date', field: 'fromDate', headerSx: { textAlign: 'right',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false, colSpan:4},
    { headerName: 'To Voucher Date', field: 'toDate', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:4},
    { headerName: 'Party City', field: 'partyCity', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:4},
    { headerName: 'Party Name', field: 'partyName', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true, colSpan:5},
    // { headerName: 'Party GSTN', field: 'voucherType', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
export const tab2Data = [
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0',editBtn:true
    },
    {isTotalRow:true,
        totalCaption:'Total',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100', discount:'600', netAmtPending:'5400'
    },
]
export const columnDefsFilter = [
    // { headerName: 'From Voucher Date', field: 'fromDate', headerSx: { textAlign: 'right',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false},
    // { headerName: 'To Voucher Date', field: 'toDate', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party City', field: 'partyCity',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party Name', field: 'partyName',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Voucher Type', field: 'voucherType',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Report type', field: 'reportType',colSpan:4, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
export const columnDefsFilterForSummary = [
    // { headerName: 'From Voucher Date', field: 'fromDate', headerSx: { textAlign: 'right',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false},
    // { headerName: 'To Voucher Date', field: 'toDate', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party City', field: 'partyCity',colSpan:2, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Party Name', field: 'partyName',colSpan:3, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Voucher Type', field: 'voucherType',colSpan:3, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Report type', field: 'reportType',colSpan:2, headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
]
export const columnDefsThree = [
    { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'left',minWidth:'3%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:false},
    { headerName: 'Voucher\nNo.', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'10%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'14.36%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'Voucher\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'12.36%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'11.24%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'11.24%' }, xlCol: { dataType: 'string', dataFormatter: null },showfilter:true},
    { headerName: 'Voucher\nAmount', field: 'TotalNetAmt', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: 'Amount\nReceived', field: 'TotalPaidAmt', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: 'Discount', field: 'Discount', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
    { headerName: 'Amount\nOutstanding', field: 'NetAmtToRcv', headerSx: { textAlign: 'right',minWidth:'11.24%' }, xlCol: { dataType: 'number', dataFormatter: null },showfilter:true},
]
export const tab3SummaryData = [
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {srNo:'1',voucherNo:'516',voucherDate:'26-Feb-24,12:00',voucherType:'Booking',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
    {isTotalRow:true,totalCaption:'Total',voucherAmount:'1000',amountReceived:'900',amountOutStanding:'100'},
]
export const columnDefsFour = [
    { headerName: 'S/N', field: 'SN', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:false},
    { headerName: 'Voucher\nNumber', field: 'VoucherNo', headerSx: { textAlign: 'left',minWidth:'50px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true},
    { headerName: 'Voucher\nDate', field: 'VoucherDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'Booking\nDate', field: 'BookingDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'LR\nNumber', field: 'LRNO', headerSx: { textAlign: 'left',minWidth:'126px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'Party\nName', field: 'Party', headerSx: { textAlign: 'left',minWidth:'140px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'Party\nGSTIN', field: 'GSTN', headerSx: { textAlign: 'left',minWidth:'125px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'Payment\nType', field: 'PaymentType', headerSx: { textAlign: 'left',minWidth:'82px'}, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'Voucher Txn.\nType', field: 'TransactionType', headerSx: { textAlign: 'left',minWidth:'60px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'GST Invoice\nNumber', field: 'GSTInv', headerSx: { textAlign: 'left',minWidth:'70px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'GST Invoice\nDate', field: 'GSTDate', headerSx: { textAlign: 'left',minWidth:'120px' }, xlCol: { dataType: 'string', dataFormatter: null }, showfilter:true },
    { headerName: 'GST Inv.\nAmount', field: 'GSTAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: 'Voucher\nAmount', field: 'TotalNetAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: 'Amount\nPaid', field: 'TotalPaidAmt', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: 'Discount', field: 'Discount', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
    { headerName: 'Amount\nPending', field: 'NetAmtToRcv', headerSx: { textAlign: 'right',minWidth:'65px' }, xlCol: { dataType: 'number', dataFormatter: null }, showfilter:true },
]

export const tab3DetailedData = [
    {isSubHeadingRow:true, partyName:'Party Name: Shivaholic Private Ltd.', partyCity:'Party City: Ahmedabad',voucherTxnType:'Voucher Type: Booking'},
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0'
    },
    {isSubTotalRow:true,totalCaption:'Total: Shivaholic Private Ltd. (Ahmedabad)',  totalCaptionAlignment: 'right',  
        colSpan: 9,voucherTxnType:'Voucher Type: Booking',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'},
    {isSubHeadingRow:true, partyName:'Party Name: Shivaholic Private Ltd.', partyCity:'Party City: Ahmedabad',voucherTxnType:'Voucher Type: Booking'},
    {srNo:'1',voucherNo:'516',voucherDate:'26 Feb-24,12:00',bookingDate:'25-Dec-24,09:51',lrNo:'MAHD/23-24/00001',partyName:'Shivaholic Private Ltd.',partyGstin:'27ABCDE1234F1Z5',paymentType:'On Account',voucherTxnType:'Booking',
        invNo:'1/100',gstinDate:'25-Dec-24,09:51',gstInvAmount:'50',voucherAmt:'1000',amtPaid:'900',amtPending:'100', discount:'100', netAmtPending:'0'
    },
    {isSubTotalRow:true,totalCaption:'Total: Shivaholic Private Ltd. (Ahmedabad)', totalCaptionAlignment: 'right',  
        colSpan: 9, voucherTxnType:'Voucher Type: Delivery',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'},
    {isTotalRow:true, totalCaption: 'Total: All',
        totalCaptionAlignment: 'right',  
        colSpan: 9,
        voucherTxnType:'Voucher Type: All',gstInvAmount:'300',voucherAmt:'6000',amtPaid:'900',amtPending:'5100'
    },
]
export const summaryTableStyles = {
    0: {cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 120.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 142.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 131.11, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 131.11, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 95, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 100, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
  }
  export const detailedTableStyles = {
    0: {cellWidth: 50, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    1: { cellWidth: 90, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    2: { cellWidth: 140, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    3: { cellWidth: 140, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    4: { cellWidth: 140, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    5: { cellWidth: 117.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    6: { cellWidth: 117.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    7: { cellWidth: 117.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    8: { cellWidth: 100, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    9: { cellWidth: 117.9, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    10: { cellWidth: 140, halign: 'left', font: 'Roboto', fontSize: 16, cellPadding:12 },
    11: { cellWidth: 80, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    12: { cellWidth: 80, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    13: { cellWidth: 80, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    14: { cellWidth: 80, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
    15: { cellWidth: 105, halign: 'right', font: 'Roboto', fontSize: 16, cellPadding:12 },
 
}

export const coloumnOnCreateVoucher = [
    {
      header: 'LR No',
      pdfHead: 'LR No.\nMan LR No',
      field: 'LRNO',
      xlCol: { dataType: 'number', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 1,
    },
  
    {
      header: 'Booking Date & Booking Time',
      pdfHead: ' Bkg. Date\nBkg. Time',
      field: 'BookingDateTime',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 2,
    },
    {
      header: 'Source City & Source Branch',
      pdfHead: 'Src. City\nSrc. Br.',
      field: 'BookingCity',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 3,
    },
    {
      header: 'Destination City & Destination Branch',
      pdfHead: 'Dst. City\nDst. Br',
      field: 'DestinationCity',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 4,
    },
  
    {
      header: 'Sender\nDetails',
      pdfHead: 'Sender\nDetails',
      field: 'Sender',
      xlCol: { dataType: 'string', dataFormatter: null, width: 4 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 5,
    },
    {
      header: 'Receiver\nDetails',
      pdfHead: 'Receiver\nDetails',
      field: 'Receiver',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left', whiteSpace: 'nowrap' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 6,
    },
    {
      header: 'Booked By User',
      pdfHead: 'Bkg. By\nUser',
      field: 'BookedBy',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 7,
    },
    {
      header: 'Item Name',
      pdfHead: 'Item\nName',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      field: 'ItemDetails',
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: false,
      isSelected: true,
      isDefault: true,
      isMandatory: true,
      id: 8,
    },
    {
      header: 'LR Status',
      pdfHead: 'LR\nStatus',
      field: 'Status',
      xlCol: { dataType: 'string', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'left' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 9,
    },
    {
      header: 'Item Units',
      pdfHead: 'Item\nUnits',
      field: 'Items',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 10,
    },
    {
      header: 'Freight Charge',
      pdfHead: 'Frt.\nChrg',
      field: 'Freight',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 11,
    },
    {
      header: 'Document Charge',
      pdfHead: 'Doc.\nChrg',
      field: 'DocumentCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 12,
    },
    {
      header: 'Cartage Charge',
      pdfHead: 'Cart.\nChrg',
      field: 'CartageAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 13,
    },
    {
      header: 'Hamali Charge',
      pdfHead: 'Ham.\nChrg',
      field: 'HamaliCharges',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 14,
    },
    {
      header: 'Operator Hamali Charge',
      pdfHead: 'op.\nHam.',
      field: 'OperatorHamaliChg',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 15,
    },
  
    {
      header: 'Valuation Charge',
      pdfHead: 'Val.\nChrg',
      field: 'Valuation',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 16,
    },
    {
      header: 'Other Charge',
      pdfHead: 'oth.\nChrg',
      field: 'OtherCharge',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 17,
    },
    {
      header: 'Booking GST',
      pdfHead: 'Bkg.\nGST',
      field: 'BookingGST',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 18,
    },
    {
      header: 'Net Amount',
      pdfHead: 'Net\nAmt',
      field: 'NetAmount',
      xlCol: { dataType: 'number', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 19,
    },
    {
      header: 'Delivery Hamali',
      pdfHead: 'Del.\nHam',
      field: 'DelHamali',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 20,
    },
    {
      header: 'DelCartage Amount',
      pdfHead: 'Del.\nCart',
      field: 'DelCartage',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 21,
    },
    {
      header: 'Demurrage Charge',
      pdfHead: 'Dem.\nChrg',
      field: 'DemurrageChg',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 22,
    },
    {
      header: 'Delivery GST',
      pdfHead: 'Del.\nGst',
      field: 'DeliveryGST',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: false,
      isSelected: true,
      isMandatory: false,
      id: 23,
    },
    {
      header: 'Net OutStanding Amount',
      pdfHead: 'NetO/S\nAmt',
      field: 'Outstanding',
      xlCol: { dataType: 'quantity', dataFormatter: null, width: 20 },
      headerSx: { width: '50%', textAlign: 'right' },
      allowSorting: true,
      isSelected: true,
      isMandatory: true,
      id: 24,
    },
  ]

 export const filterSummary= {
    0: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    1: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    2: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    3: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    4: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    5: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 295, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
  }
 export const filterDetailed= {
    0: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    1: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    2: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    3: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    4: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
    5: { textColor: [0, 0, 0], fontSize: 16, cellPadding: 12, minCellHeight: 36, cellWidth: 423, valign: 'middle', font: 'Roboto', fontStyle: 'normal', halign: 'left' },
  }